
<button routerLink="/auth/login" class="column" type="button" mat-button color="secondary">
  <mat-icon iconPositionStart>arrow_back</mat-icon>
  RECOVER YOUR PASSWORD
</button>

<form #form="ngForm" (ngSubmit)="sendEmail()">
  <div class="Frame11" style="flex-direction: column; justify-content: center; align-items: center; gap: 72px; display: flex">
    <div class="Frame53" style="align-self: stretch; height: 276px; flex-direction: column; justify-content: center; align-items: center; gap: 32px; display: flex">
      <div class="Formlabel" style="color: rgba(0, 0, 0, 0.87); font-size: 15px; font-family: Roboto; font-weight: 500; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">In order to reset your password, provide your account email address below and press send code</div>
      <div class="Frame56">
        <div class="Frame9" >
          <div class="Frame6">
            <mat-form-field  appearance="outline" class="text-field">
              <mat-label>Email address</mat-label>
              <input matInput type="email" [formControl]="emailFormControl" required>
              <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="emailFormControl.hasError('required')">
                Email address is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <button class="button-tourist" [disabled]="!isFormValid()" type="submit" mat-raised-button>SEND CODE
          <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
